import { render, staticRenderFns } from "./ServiceRequestView.vue?vue&type=template&id=378ae912&"
import script from "./ServiceRequestView.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestView.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRequestView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports